
import React, { useEffect, useState } from 'react';
import ModalWrap from 'components/Modals/ModalWrap';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, MenuItem, IconButton } from '@material-ui/core';
import { LEAD_TYPES, CATALOGUE_TYPE_PACK, DEPARTMENTS } from 'config'
import moment from 'moment'
import CustomTextInput from 'components/CustomTextInput';
import CustomCommonSelect from 'components/CustomCommonSelect';
import CustomTable from 'components/CustomTable'
import * as API from 'services/api';
import PropTypes from 'prop-types';
import { tableOptions } from 'pages/common';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { showMessage } from 'utils';

const useStyles = makeStyles(theme => ({
    root: {},
    label: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1)
    },
    item: {
        margin: theme.spacing(1),
        marginLeft: 0
    },
    description: {
        margin: theme.spacing(0, 1)
    }
}));
const FormDetails = ({ formatMessage, data, open, handleClose, companies }) => {
    const classes = useStyles();
    const [recipients, setRecipients] = useState([]);
    const [mainCompany, setMainCompany] = useState(null);
    const { source, userId, type, recipientInfo, clientId } = data;

    useEffect(() => {
        if (open) {
            API.getLead(data.id).then(res => {
                if (res.code == 200) {
                    setRecipients(res.data.source.recipients)
                    if (res.data.mainCompany) {
                        setMainCompany(res.data.mainCompany)
                    }
                }
            })
        }
    }, [open]);

    const packData = source?.data ? JSON.parse(source.data) : null;

    const traineeTable = trainee.map(key => ({
        name: key,
        label: formatMessage({ id: "leads.form." + key.toLowerCase() }),
        options: {
            display: true,
            sort: false,
            customBodyRender: (_value, tableMeta) => {
                let value = _value;
                if (key == "birth") value = _value ? moment(_value).format("DD/MM/YYYY") : "";
                if (key == "region") {
                    const depart = DEPARTMENTS.find(el => el.id == value)
                    value = depart ? depart.label : value
                }
                if (key == "gender") {
                    value = value ? formatMessage({ id: "leads.form.gender." + value }) : ""
                }
                return value
            }
        }
    }));

    const recieptTable = recipientsFields.map(key => ({
        name: key,
        label: formatMessage({ id: "leads.form." + key }),
        options: {
            display: true,
            sort: false,
        }
    }));

    const recieptTable1 = [
        {
            name: "firstName",
            label: formatMessage({ id: "leads.form.firstname" }),
            options: {
                display: true,
                sort: false,
            }
        },
        {
            name: "lastName",
            label: formatMessage({ id: "leads.form.lastname" }),
            options: {
                display: true,
                sort: false,
            }
        },
        {
            name: "email",
            label: formatMessage({ id: "leads.form.email" }),
            options: {
                display: true,
                sort: false,
            }
        }
    ];
    const company = companies.find(el => el.id == clientId);

    return (
        <ModalWrap
            title={"Lead"}
            open={open}
            closeModal={handleClose}
        >
            <div>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={'PRODUIT :'}
                    value={source.title || ""}
                    disabled
                    multiline
                />
                {
                    type == LEAD_TYPES[4] ? //product request
                        <RequestForm
                            userId={userId}
                            data={data}
                            source={source}
                            formatMessage={formatMessage}
                        />
                        :
                        <>

                            {
                                source.productType == CATALOGUE_TYPE_PACK ?
                                    (
                                        packData &&
                                        <>
                                            <br />
                                            <br />
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography className={classes.label}><strong>PRODUITS</strong></Typography>
                                                    {
                                                        packData.products.map(el => <Typography key={el.id} className={classes.item}>- {el.title}</Typography>)
                                                    }
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {
                                                        packData.options.length > 0 &&
                                                        <>
                                                            <Typography className={classes.label}><strong>OPTIONS (valable uniquement en plus du pack)</strong></Typography>
                                                            {
                                                                packData.options.map(el => <Typography key={el.id} className={classes.item}>- {el.title}</Typography>)
                                                            }
                                                        </>
                                                    }
                                                </Grid>
                                            </Grid>

                                            <CustomTextInput
                                                fullWidth
                                                variant="outlined"
                                                label={'PRIX H.T. :'}
                                                value={`${packData.packPrice}€ HT`}
                                                disabled
                                            />
                                            <br />
                                            <br />
                                            <Typography variant="h5" className={classes.label}><strong>SIGNATAIRE</strong></Typography>
                                            <div style={{ marginLeft: 16 }}>
                                                <Grid container spacing={2} >
                                                    {
                                                        signatorInfo.map(el => {
                                                            return <Grid key={el} item xs={4}>
                                                                <CustomTextInput
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    label={`${formatMessage({ id: "leads.form." + el })} :`}
                                                                    value={packData.signatorInfo[el]}
                                                                    disabled
                                                                />
                                                            </Grid>
                                                        })
                                                    }
                                                </Grid>
                                            </div>
                                            <br />
                                            <Typography variant="h5" className={classes.label}><strong>FACTURATION</strong></Typography>
                                            <div style={{ marginLeft: 16 }}>
                                                <Grid container spacing={2} >
                                                    {
                                                        billingInfo.map(el => {
                                                            return <Grid key={el} item xs={4}>
                                                                <CustomTextInput
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    label={`${formatMessage({ id: "leads.form." + el })} :`}
                                                                    value={packData.billingInfo[el]}
                                                                    disabled
                                                                />
                                                            </Grid>
                                                        })
                                                    }
                                                </Grid>
                                            </div>
                                            <br />
                                            <Typography variant="h5" className={classes.label}><strong>DESTINATAIRE(S) DU RAPPORT</strong></Typography>
                                            <CustomTable
                                                columns={recieptTable}
                                                data={packData.recipients}
                                                options={tableOptions(formatMessage)}
                                            />
                                            <br />
                                            <br />
                                        </>
                                    ) :
                                    <>
                                        {
                                            renderGeneral(source, packData, traineeTable, classes, formatMessage)
                                        }
                                        {
                                            recipientInfo &&
                                            <>
                                                {
                                            renderSignatorInfo(recipientInfo, classes, formatMessage, company, userId, packData, mainCompany, recipients, recieptTable1)
                                                }
                                                {
                                                    renderBillingInfo(recipientInfo, classes, formatMessage)
                                                }
                                            </>
                                        }
                                    </>
                            }
                        </>
                }
            </div>
        </ModalWrap>
    );
};

FormDetails.propTypes = {};

export default FormDetails;

const signatorInfo = [
    "company", "siret", "address", "zipcode", "city", "lastname", "firstname", "function", "phone", "email"
]
const billingInfo = [
    "company", "siret", "address", "zipcode", "city", "phone", "email"
]
const recipientsFields = [
    "lastname", "firstname", "function", "phone", "email"
]

const trainee = [
    "gender", "lastName", "firstName", "birth", "establishment" //"region"
]
const CIVILITIES = [
    'madame',
    'monsieur',
    'sir',
    'madam',
]
const FUNCTIONS = [
    "achat_chain",
    "designoffice",
    "commercial",
    "communication",
    "dirigeant",
    "finances",
    "fonctionnaire",
    "asset",
    "it",
    "marketing",
    "QHSE",
    "RH",
    "services",
    "support",
]

const REQUESTTYPES = [
    'quote',
    'additional',
    'invoice',
    'other'
]

const COUNTRIES = [
    "France",
    "Angola",
    "Arabie Saoudite",
    "Belgique",
    "Bénin",
    "Birmanie",
    "Brunei",
    "Burkina Faso",
    "Cameroun",
    "Chine",
    "Corée du Sud",
    "Côte d Ivoire",
    "Croatie",
    "Danemark",
    "Émirats Arabes Unis",
    "Espagne",
    "Etats Unis",
    "Gabon",
    "Ghana",
    "Guinée Conakry",
    "Guinée Equatoriale",
    "Île Maurice",
    "Inde",
    "Indonésie",
    "Italie",
    "Japon",
    "Koweït",
    "Macédoine",
    "Madagascar",
    "Malaisie",
    "Mali",
    "Maroc",
    "Martinique",
    "Monaco",
    "Oman",
    "Pays-Bas",
    "Pologne",
    "Qatar",
    "Royaume-Uni",
    "Sénégal",
    "Serbie",
    "Singapour",
    "Tchad",
    "Thaïlande",
    "Tunisie",
    "Vietnam",
    "Autre",
];
const fields = [
    { field: "civility", values: CIVILITIES, transKey: "contact.field.civility." },
    { field: "firstName" },
    { field: "lastName" },
    { field: "email" },
    { field: "phone" },
    { field: "country", values: COUNTRIES },
    { field: "company" },
    { field: "function", values: FUNCTIONS, transKey: "contact.field.function." },
    { field: "activity", noRequired: true },
    { field: "requesttype", values: REQUESTTYPES, transKey: "contact.field.requesttype." }
]



const RequestForm = ({ userId, data, source, formatMessage }) => {
    const sourceData = source?.data ? JSON.parse(source.data) : null;
    const [agency, setAgency] = useState(null);
    
    useEffect(() => {
        const codePostal = !userId && sourceData?.postalCode ? sourceData.postalCode : data.owner_zipCode || source.zipCode;
        if (codePostal) {
            API.getAgenciesWithCodepostal({ codePostal }).then(res => {
                if (res.code == 200) {
                    setAgency(res.data[0])
                }
            })
        }
    }, [source])

    const agencyField = <>
        <CustomTextInput
            fullWidth
            variant="outlined"
            label={'Comment :'}
            value={source.description || ""}
            disabled
            multiline
        />
        {
            agency &&
            <Grid item xs={12} style={{ marginBottom: 24 }}>
                <Grid container >
                    <Grid item style={{ flexGrow: 1 }}>
                        <CustomTextInput
                            fullWidth
                            label={"Agence"}
                            value={agency.name}
                            variant="outlined"
                            disabled
                        />
                    </Grid>
                    &nbsp;&nbsp;&nbsp;
                    <Grid item>
                        <IconButton
                            onClick={() => {
                                API.sendNotificationToAgency({
                                    email: agency.agencyEmail.replace(/[\n\r]/g, ''),
                                    body: `
                                    <strong>ID</strong>: ${data.id} <br/>
                                    <strong>Nom</strong>: ${!userId ? sourceData.lastName : data.owner_lastName} <br/>
                                    <strong>Prénom</strong>: ${!userId ? sourceData.firstName : data.owner_firstName} <br/>
                                    <strong>Email</strong>: ${!userId ? sourceData.email : data.owner_email} <br/>
                                    <strong>Code postal</strong>: ${!userId ? sourceData.postalCode : data.owner_zipCode} <br/>
                                    <strong>Produit</strong>: ${source.title} <br/>
                                    <strong>Commentaire</strong>: ${source.description || ""} <br/>
                                    `
                                }).then(res => {
                                    if (res.code == 200) {
                                        showMessage({
                                            message: "sent successfully",
                                            type: 'success',
                                        });

                                    } else {
                                        showMessage({
                                            message: "Internal server error",
                                            type: 'danger',
                                        });
                                    }
                                })
                            }}
                            size='small'
                            style={{ marginTop: 50 }}
                        >
                            <NotificationsIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
        }
    </>;

    if (!userId) {
        return <Grid container spacing={1}>
            {
                fields.map(item =>
                    <>
                        <Grid key={item.field} item xs={6}>
                            {
                                item.values ?
                                    <CustomCommonSelect
                                        fullWidth
                                        value={sourceData[item.field]}
                                        variant="outlined"
                                        select
                                        disabled
                                        label={formatMessage({ id: "contact.field." + item.field })}
                                    >
                                        <MenuItem value="">{formatMessage({ id: "selectplaceholder" })}</MenuItem>
                                        {
                                            item.values.map(id => <MenuItem key={id} value={id}>{item.transKey ? formatMessage({ id: item.transKey + id }) : id}</MenuItem>)
                                        }
                                    </CustomCommonSelect> :
                                    <CustomTextInput
                                        label={formatMessage({ id: "contact.field." + item.field })}
                                        fullWidth
                                        value={sourceData[item.field]}
                                        variant="outlined"
                                        disabled
                                    />
                            }
                        </Grid>
                        {
                            item.field == "country" && sourceData[item.field] == "France" &&
                            <>
                                <Grid key={item.field} item xs={6}>
                                    <CustomTextInput
                                        label={"Code postal"}
                                        fullWidth
                                        value={sourceData["postalCode"]}
                                        variant="outlined"
                                        disabled
                                    />
                                </Grid>
                                <Grid key={item.field} item xs={6}>
                                    <CustomTextInput
                                        label={"SIRET"}
                                        fullWidth
                                        value={sourceData["siret"]}
                                        variant="outlined"
                                        disabled
                                    />
                                </Grid>
                            </>
                        }
                    </>
                )
            }
            {agencyField}
        </Grid>
    }
    return <>
        <Grid container spacing={2} >
            <Grid item xs={6}>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={`${formatMessage({ id: "leads.form.firstname" })} :`}
                    value={userId ? data.owner_firstName : source.firstName}
                    disabled
                />
            </Grid>
            <Grid item xs={6}>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={`${formatMessage({ id: "leads.form.lastname" })} :`}
                    value={userId ? data.owner_lastName : source.lastName}
                    disabled
                />
            </Grid>
            <Grid item xs={6}>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={`${formatMessage({ id: "leads.form.email" })} :`}
                    value={userId ? data.owner_email : source.email}
                    disabled
                />
            </Grid>
            <Grid item xs={6}>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={`Code postal :`}
                    value={userId ? data.owner_zipCode : source.zipCode}
                    disabled
                />
            </Grid>
        </Grid>
        {agencyField}
    </>
}
RequestForm.propTypes = {
    userId: PropTypes.string,
    data: PropTypes.any,
    source: PropTypes.any,
    formatMessage: PropTypes.func
}

const renderGeneral = (source, packData, traineeTable, classes, formatMessage) => {
    return source.intra ?
        <>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <CustomTextInput
                        fullWidth
                        variant="outlined"
                        label={'Nombre de stagiaire :'}
                        value={source.traineeCount}
                        disabled
                    />
                </Grid>
                <Grid item xs={6}>
                    <CustomTextInput
                        fullWidth
                        variant="outlined"
                        label={'Date souhaité :'}
                        value={moment(source.orderDate).format("DD/MM/YYYY")}
                        disabled
                    />
                </Grid>
            </Grid>
        </> :
        <>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <CustomTextInput
                        fullWidth
                        variant="outlined"
                        label={'PRODUIT CODE :'}
                        value={packData?.ref_id}
                        disabled
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomTextInput
                        fullWidth
                        variant="outlined"
                        label={'PRIX :'}
                        value={`${Number.parseFloat(source.price) * source.quantity}€`}
                        disabled
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomTextInput
                        fullWidth
                        variant="outlined"
                        label={'CHOISIR UNE DATE :'}
                        value={packData?.training_date ? moment(packData?.training_date).format("DD/MM/YYYY") : ""}
                        disabled
                    />
                </Grid>
            </Grid>
            <NationalProduct source={source} />
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <CustomTextInput
                        fullWidth
                        variant="outlined"
                        label={'RÉGION :'}
                        value={packData?.training_location_title}
                        disabled
                    />
                </Grid>
                <Grid item xs={6}>
                    <CustomTextInput
                        fullWidth
                        variant="outlined"
                        label={'MERCI DE CHOISIR UN CENTRE DE FORMATION :'}
                        value={packData?.training_center_name}
                        disabled
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CustomTextInput
                        fullWidth
                        variant="outlined"
                        label={'Commentaires :'.toUpperCase()}
                        value={source.description}
                        multiline 
                        rows={3}
                        disabled
                    />
                </Grid>
            </Grid>
            <Typography className={classes.label}><strong>Veuillez compléter les informations ci-dessous pour chaque participant :</strong></Typography>
            <CustomTable
                columns={traineeTable}
                data={(source.trainees || []).filter(el => el).map(el => ({ ...el, establishment: el.company }))}
                options={tableOptions(formatMessage)}
            />
        </>
}
const renderSignatorInfo = (recipientInfo, classes, formatMessage, company, userId, packData, mainCompany, recipients, recieptTable1) => {
    // Use mainCompany if company is empty
    const companyToShow = company || mainCompany;
    return recipientInfo.signatorInfo?.email ? <>
        <br />
        <Typography variant="h5" className={classes.label}><strong>SIGNATAIRE ({recipientInfo.signatorInfo.isParticular ? "Particulier" : "Entreprise"})</strong></Typography>
        <div style={{ marginLeft: 16, marginBottom: 16 }}>
            <Grid container spacing={2}>
                {
                    !recipientInfo.signatorInfo.isParticular &&
                    <>
                        <Grid item xs={4}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={'Dénomination sociale :'}
                                value={recipientInfo.signatorInfo.company}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={'Siret :'}
                                value={recipientInfo.signatorInfo.siret}
                                disabled
                            />
                        </Grid>
                    </>
                }
            </Grid>
            {renderRecipientsTable(recipients, recieptTable1, classes, formatMessage)}
            {renderCompany(recipientInfo.signatorInfo)}
        </div>
    </> :
        <>
            {renderDestinataires(classes, formatMessage, userId, packData, company, mainCompany)}
            {renderRecipientsTable(recipients, recieptTable1, classes, formatMessage)}
            {
                companyToShow &&
                <>
                    <br />
                    <Typography variant="h5" className={classes.label}><strong>Enterprise</strong></Typography>
                    <div style={{ marginLeft: 16, marginBottom: 16 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <CustomTextInput
                                    fullWidth
                                    variant="outlined"
                                    label={'Dénomination sociale :'}
                                    value={companyToShow.company}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <CustomTextInput
                                    fullWidth
                                    variant="outlined"
                                    label={'Siret :'}
                                    value={companyToShow.siret}
                                    disabled
                                />
                            </Grid>
                        </Grid>
                        {renderCompany(companyToShow)}
                    </div>
                </>
            }
        </>
}

const renderBillingInfo = (recipientInfo, classes, formatMessage) => {
    return recipientInfo.billingInfo &&
        <>
            <br />
            <Typography variant="h5" className={classes.label}><strong>FACTURATION DE LA FORMATION ({formatMessage({ id: "leads.form.invoicetype." + (recipientInfo.billingInfo.invoiceType || "billing") })})</strong> </Typography>
            {
                !recipientInfo.signatorInfo.isParticular &&
                <div style={{ marginLeft: 16, marginBottom: 16 }}>
                    <Grid container spacing={2} >
                        <Grid item xs={4}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={recipientInfo.billingInfo.isOPCO && "Nom de l’organisme :" || "Dénomination sociale :"}
                                value={recipientInfo.billingInfo.company}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextInput
                                fullWidth
                                variant="outlined"
                                label={recipientInfo.billingInfo.isOPCO && "Numéro d’adhérent auprès de l’OPCO :" || "Siret :"}
                                value={recipientInfo.billingInfo.siret}
                                disabled
                            />
                        </Grid>
                        {renderAddress(recipientInfo.billingInfo)}
                    </Grid>
                </div>
            }
        </>
}

const renderDestinataires = (classes, formatMessage, userId, packData, company, mainCompany) => {
    if (!userId) return null
    // Use mainCompany if company is empty
    const companyToShow = company || mainCompany;
    return <>
        <br />
        <Typography variant="h5" className={classes.label}><strong>{packData?.company?._id ? "Destinataires" : "Destinataires Offre"}</strong></Typography>
        <div style={{ marginLeft: 16, marginBottom: 16 }}>
            {
                packData?.company?._id ?
                    <>
                        <Grid container spacing={2}>
                            {
                                ['name',
                                    'siret',
                                    'email',
                                    'address',
                                    'zipCode',
                                    'city',
                                    'pays'].map(key => {
                                        return <Grid key={key} item xs={4}>
                                            <CustomTextInput
                                                fullWidth
                                                variant="outlined"
                                                label={formatMessage({ id: 'home.clients.establishments.' + key }) + ' :'}
                                                value={packData.company[key]}
                                                disabled
                                            />
                                        </Grid>
                                    })
                            }
                        </Grid>
                    </> :
                    renderCompany(companyToShow)
            }
        </div>
    </>
}
const renderAddress = (company) => {
    return <>
        <Grid item xs={4}>
            <CustomTextInput
                fullWidth
                variant="outlined"
                label={'Adresse postale :'}
                value={company.address}
                disabled
            />
        </Grid>
        <Grid item xs={4}>
            <CustomTextInput
                fullWidth
                variant="outlined"
                label={'Code postal :'}
                value={company.zipcode || company.zipCode}
                disabled
            />
        </Grid>
        <Grid item xs={4}>
            <CustomTextInput
                fullWidth
                variant="outlined"
                label={'Ville :'}
                value={company.city}
                disabled
            />
        </Grid>
        <Grid item xs={4}>
            <CustomTextInput
                fullWidth
                variant="outlined"
                label={'Pays :'}
                value={company.country}
                disabled
            />
        </Grid>
    </>
}
const renderCompany = (company) => {
    return company ?
        <Grid container spacing={2}>
            {renderAddress(company)}
            <Grid item xs={4}>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={'Nom signataire :'}
                    value={company.lastname || company.lastName}
                    disabled
                />
            </Grid>
            <Grid item xs={4}>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={'Prénom signataire :'}
                    value={company.firstname || company.firstName}
                    disabled
                />
            </Grid>
            <Grid item xs={4}>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={'Téléphone :'}
                    value={company.phone}
                    disabled
                />
            </Grid>
            <Grid item xs={4}>
                <CustomTextInput
                    fullWidth
                    variant="outlined"
                    label={'Email :'}
                    value={company.email}
                    disabled
                />
            </Grid>
        </Grid> :
        <Typography variant="h6" style={{ textAlign: "center" }}>The user who created this order is deleted.</Typography>
}

const renderRecipientsTable = (recipients, recieptTable1, classes, formatMessage) => {
    return recipients && recipients.length > 0 &&
        <>
            <Typography variant="h5" className={classes.label}><strong>Destinataire(s) de l'offre</strong></Typography>
            <CustomTable
                columns={recieptTable1}
                data={recipients}
                options={tableOptions(formatMessage)}
            />
        </>
}
FormDetails.propTypes = {
    formatMessage: PropTypes.func,
    data: PropTypes.any,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    companies: PropTypes.any
};


const NationalProduct = ({ source }) => {
    const [product, setProduct] = useState(null);

    useEffect(() => {
        if (source?.productId && source?.productType == "national") {
            API.getNationalProduct(source.productId).then(res => {
                if (res.code == 200) {
                    setProduct(res.data)
                }
            })
        }
    }, []);

    return product && <Grid container spacing={2}>
        <Grid item xs={4}>
            <CustomTextInput
                fullWidth
                variant="outlined"
                label={'Référence Client :'}
                value={product?.client}
                disabled
            />
        </Grid>
        <Grid item xs={8}>
            <CustomTextInput
                fullWidth
                variant="outlined"
                label={'Titre du Produit Client :'}
                value={product?.title}
                disabled
            />
        </Grid>
    </Grid>
}
NationalProduct.propTypes = {
    source: PropTypes.any
}